import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { PageActivityEditDTO } from '@next-space/fe-api-idl';
import type { FC } from 'react';

import { CollectionViewSubject } from '../subject';
import { FeedTemplate } from './feed-template';

export const CollectionViewCreatedFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();

  if (edit.collectionViewData?.current == null) return null;
  return (
    <FeedTemplate
      edits={[edit]}
      action={t('components.page_feeds.view_created')}
      subject={<CollectionViewSubject view={edit.collectionViewData.current} />}
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};

export const CollectionViewChangedFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();

  if (edit.collectionViewData?.after == null) return null;
  return (
    <FeedTemplate
      edits={[edit]}
      action={t('components.page_feeds.view_edited')}
      subject={<CollectionViewSubject view={edit.collectionViewData.after} />}
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};

export const CollectionViewDeletedFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();

  if (edit.collectionViewData?.current == null) return null;
  return (
    <FeedTemplate
      edits={[edit]}
      action={t('components.page_feeds.view_deleted')}
      subject={<CollectionViewSubject view={edit.collectionViewData.current} />}
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};
